import { InnerBlocks } from '@wordpress/block-editor';
import React from 'react';
import style from './block.module.scss';
import {
    BlockWrapper,
    ChildrenBlock,
    defineBlock,
    smartProps,
    useEditor,
    useInspectorControl,
} from '@smartfire/js-block-engine';
import { EditableText, EditableImg } from '@smartfire/components';

const TEMPLATE = [['smartfire/events---calendar', {}]];
const InspectorLazy = React.lazy(() => import('./Inspector'));
function Block({ link1, link2, link3 }) {
    useInspectorControl(InspectorLazy, []);
    const { isEditing } = useEditor();
    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.content}>
                <div className={style.left}>
                    <EditableText
                        tagName="h2"
                        className={style.title}
                        placeholder="ajouter un texte"
                        smartProp="title"
                        allowedFormats={['core/link']}
                    />
                    <EditableText
                        className={style.subtitle}
                        placeholder="ajouter un texte"
                        smartProp="subtitle"
                        allowedFormats={['core/bold', 'advanced/color', 'core/italic', 'core/link']}
                    />
                    <div className={style.grid}>
                        <a href={!isEditing && link1 && link1}>
                            <EditableImg smartProp="image1" />
                            <EditableText smartProp="text1" className={style.text} />
                        </a>
                        <a href={!isEditing && link2 && link2}>
                            <EditableImg smartProp="image2" />
                            <EditableText smartProp="text2" className={style.text} />
                        </a>
                        <a href={!isEditing && link3 && link3}>
                            <EditableImg smartProp="image3" />
                            <EditableText smartProp="text3" className={style.text} />
                        </a>
                    </div>
                    <EditableText
                        className={style.contentGris}
                        placeholder="ajouter un texte"
                        smartProp="grisText"
                        allowedFormats={['core/bold', 'advanced/color', 'core/italic', 'core/link']}
                    />
                </div>
                {isEditing ? (
                    <InnerBlocks
                        className={style.right}
                        allowedBlocks={['smartfire/events---calendar']}
                        template={TEMPLATE}
                    />
                ) : (
                    <div className={style.right}>
                        <ChildrenBlock />
                    </div>
                )}
            </div>
        </BlockWrapper.Div>
    );
}

export default defineBlock({
    Block: Block as React.FC<unknown>,
    smartProps: {
        title: smartProps.string.withDefault('Visitez le château et découvrez son univers'),
        subtitle: smartProps.string.withDefault(''),
        image1: smartProps.image.withDefault(null),
        text1: smartProps.string.withDefault('visites libres'),
        link1: smartProps.string.withDefault(''),
        image2: smartProps.image.withDefault(null),
        text2: smartProps.string.withDefault('groupe d’enfants et ateliers'),
        link2: smartProps.string.withDefault(''),
        image3: smartProps.image.withDefault(null),
        text3: smartProps.string.withDefault('entreprises et associations'),
        link3: smartProps.string.withDefault(''),
        grisText: smartProps.string.withDefault('Pour plus de renseignements, n’hésitez pas à nous contacter.'),
    },
    setup: {
        title: 'Calendrier Accueil',
        icon: 'calendar-alt',
    },
});
